<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                    <div  v-if="!fileUploaded && percentage" class="loader__text">Probíhá nahrávání souboru - {{percentage}}%</div>

                </div>
            </div>

        </div>

       <div class="content" v-else>

               <h1 v-if="type === 'add'">
                    Nahrání souboru
               </h1>
               <h1 v-else>
                    Detail souboru
               </h1>


           <v-layout>
               <table class="info-table">
                   <tr>
                       <td class="info-table__title">
                           Soubor
                       </td>
                       <td class="info-table__value">
                         <div v-if="data.file && fileSelected">
                           <b>Vybraný soubor: </b>{{data.file}}
                           <br>
                           <div v-if="fileFailed" class="v-messages theme--light error--text">Soubor se nepodařilo nahrát</div>
                         </div>
                           <div class="image-controls"  v-if="fileUploaded || fileFailed">
                               <v-btn
                                       @click="selectFile()"
                                       v-if="!data.file"
                                       color="primary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat
                               </v-btn>
                               <v-btn
                                       @click="selectFile()"
                                       v-if="data.file"
                                       color="secondary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat jiný
                               </v-btn>
                               <v-btn
                                       @click="removeFile()"
                                       v-if="data.file"
                                       color="error"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Smazat
                               </v-btn>
                           </div>
                       </td>
                   </tr>
                 <tr v-if="type !== 'add'">
                   <td class="info-table__title">
                     URL
                   </td>
                   <td class="info-table__value info-table__value--text">
                     <a target="_blank" :href="data.file_url">{{data.file_url}}</a>
                   </td>
                 </tr>
                   <tr v-if="type !== 'add'">
                       <td class="info-table__title">
                           ID:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   disabled
                                   class="input--small"
                                   outlined
                                   @input="errors.id = ''"
                                   v-model="data.id"
                                   :error-messages="makeError(errors.id)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Slug: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.slug = ''"
                                   v-model="data.slug"
                                   :error-messages="makeError(errors.slug)"
                           >
                           </v-text-field>
                       </td>
                   </tr>

               </table>

           </v-layout>


           <v-layout>
               <div class="controls-table">
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="addFile()"
                           v-if="type === 'add'
                    ">
                       Vytvořit
                   </v-btn>
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="editFile()"
                           v-else
                    >
                       Uložit
                   </v-btn>
                   <v-btn
                           color="error"
                           class="button--control"
                           @click="openDialogDelete()"
                           v-if="type !== 'add'"
                   >
                       Smazat
                   </v-btn>
               </div>
           </v-layout>

           <v-dialog v-model="dialogDelete" persistent>
               <v-card>
                   <v-card-title class="headline">Smazání souboru</v-card-title>
                   <v-card-text>
                       Opravdu si přejete smazat soubor <strong>{{data.file}}</strong>?
                   </v-card-text>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn
                               color="empty"
                               class="button--dialog"
                               @click="closeDialogDelete()"
                       >
                           zrušit
                       </v-btn>
                       <v-btn
                               color="error"
                               class="button--dialog"
                               @click="deleteFile()"
                       >
                           smazat
                       </v-btn>
                       <v-spacer></v-spacer>
                   </v-card-actions>
               </v-card>
           </v-dialog>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'FilesDetail',
        components: {
        },

        data() {
            return {
              percentage: "0",
              fileUploaded: true,
              fileFailed: false,
                dialogDelete:false,
              fileSelected: false,
                type: 'add',
                loaded: false,
                data: {},
              dataOriginal: {},
                errors: {}

            }
        },

        created() {

            const vm = this;
            this.$root.$on('upload-file', () => {
                vm.fileUploaded = false;
                vm.$forceUpdate();
            });

          this.$root.$on('failed-file', () => {
            vm.fileFailed = true;
            vm.$forceUpdate();
          });


          this.$root.$on('selected-file', (files) => {
            vm.fileSelected = true;
            vm.data.file = files[0].name;
            vm.$forceUpdate();
          });

          this.$root.$on('percentage-file', (percentage) => {
            vm.percentage = parseFloat(percentage).toFixed(0);
            vm.$forceUpdate();
          });


          this.$root.$on('uploaded-file', (response) => {
     /*           vm.data.file = response.file;
                vm.data.file_url = response.url;*/
                vm.fileUploaded = true;
              vm.fileSelected = false;
                vm.$forceUpdate();
              this.$router.push({name: 'Files'});
            });
            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){
        },
        methods: {
            selectFile(){
              this.fileFailed = false;
              this.fileUploaded = true;
              this.fileSelected = false;
                this.$root.$emit('select-file');
            },
            removeFile(){
                this.data.file = null;
                this.data.file_url = null;
                this.$forceUpdate();
            },
            makeError(item){
                if(item === 'required'){
                    return 'Toto pole je povinné';
                }else if(item === 'already_used'){
                    return 'Je již používaný';
                }else if(item === 'not_valid'){
                    return 'Neplatný formát';
                }else if(item){
                    return 'Neznámá chyba';
                }else{
                    return '';
                }

            },
            openDialogDelete(){
                this.dialogDelete = true;
            },
            closeDialogDelete(){
                this.dialogDelete = false;
            },

            addFile(){
                this.loaded = false;
                const request = this.data;
                this.$axios.post('/admin/files/add', request).then((response) => {
                  if(this.fileSelected && response.data.id ){
                    this.fileUploaded = false;
                    this.$root.$emit('start-upload-file', response.data.id);
                  }else{
                    this.$router.push({name: 'Files'});
                  }
                }).catch((e) => {
                    if(e.response.data.error_inputs){
                        this.errors = e.response.data.error_inputs
                    }
                    this.loaded = true;
                });
            },
            editFile(){
                this.loaded = false;
                const request = this.data;
              console.log('this.data.file',this.data.file)
              console.log('this.dataOriginal.file',this.dataOriginal.file)
                this.$axios.put('/admin/files/'+this.$route.params.id+'/edit', request).then((response) => {

                  if(this.fileSelected && this.data.file){
                    this.fileUploaded = false;
                    this.$root.$emit('start-upload-file', this.$route.params.id);
                  }else{
                    this.$router.push({name: 'Files'});
                  }

                }).catch((e) => {
                    this.errors = e.response.data.error_inputs;
                    this.loaded = true;
                });
            },
            deleteFile(){
                this.loaded = false;
                const request = this.data;
                this.$axios.delete('/admin/files/'+this.$route.params.id+'/delete', request).then((response) => {
                    this.$router.push({name: 'Files'});
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            fetchData(){

                if(this.$route.params.id === 'add'){
                    this.type = 'add';
                    this.data = {};
                    this.loaded = true;

                }else{
                    this.type = 'detail';
                    this.$axios.get('/admin/files/' + this.$route.params.id).then((response) => {
                        this.type = 'detail';
                        this.data = response.data.file;
                        this.dataOriginal = response.data.file;
                        this.loaded = true;
                    }).catch((e) => {
                        this.$router.push({name: 'Files'});
                        this.loaded = true;
                    });
                }
            },



        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
